import AbstractController from "../../../../../vendors/services/abstractController";
import EventoModel from "../../../../shared/model/evento.model";
import { useState } from "react";
import EventoService from "../../../../services/evento.service";
import ConvidadosService from "../../../../services/convidados.service";
import ContribuicaoService from "../../../../services/contribuicao.service";
import ToastService from "../../../../../vendors/services/toastService";
import { Mensagem } from "../../../../shared/mensagem/Mensagem";
import FileService from "../../../../services/file.service";
import EventoConstants from "../utils/EventoConstants";
import { isEventoInterno, ativarLayoutEventoInterno } from "../../../../shared/utils/EventoInternoUtil";

export default class EventoVisualizarController extends AbstractController {
  private codContribuinteLogado: any;
  private setCodContribuinteLogado: any;
  private convidadosService = new ConvidadosService();

  public service: EventoService;

  public contribuicaoService: ContribuicaoService;

  public fileService: FileService;

  public evento: EventoModel;

  public tpReuniao: any;
  public setTpReuniao: any;

  public show: any;
  public setShow: any;
  public tab: any;
  public setTab: any;

  public visibleLogin: any;
  public setVisibleLogin: any;
  public isBlock: any;
  public setIsBlock: any;
  public lista: any;
  public setLista: any;

  public existeContribuicao: boolean;
  public setExisteContribuicao: any;

  public empresaList: any;
  public setEmpresaList: any;
  public cpf: any;
  public setCpf: any;
  public noUsuarioCadastro: any;
  public setNoUsuarioCadastro: any;

  public abaList: any;
  public setAbaList: any;

  public sessaoList: any;
  public setSessaoList: any;

  public lazyParams: any;
  public setLazyParams: any;
  public total: any;
  public setTotal: any;

  public isCardExpanded: boolean;
  public setIsCardExpanded: React.Dispatch<React.SetStateAction<boolean>>;

  public dispositivoLogin: any;
  public setDispositivoLogin: any;

  public contribuicoesPublicadas: any;
  public setContribuicoesPublicadas: any;

  public dsLinkNormaDefinitiva: any;
  public setDsLinkNormaDefinitiva: any;

  constructor(isBlock: any) {
    super();

    [this.show, this.setShow] = useState(true);
    [this.tab, this.setTab] = useState("contribuir");
    [this.isBlock, this.setIsBlock] = useState(isBlock);
    [this.isCardExpanded, this.setIsCardExpanded] = useState(false);

    [this.visibleLogin, this.setVisibleLogin] = useState(false);
    [this.lista, this.setLista] = useState([]);
    [this.empresaList, this.setEmpresaList] = useState([]);
    [this.cpf, this.setCpf] = useState("");
    [this.noUsuarioCadastro, this.setNoUsuarioCadastro] = useState("");
    [this.abaList, this.setAbaList] = useState([]);
    [this.sessaoList, this.setSessaoList] = useState([]);
    [this.dispositivoLogin, this.setDispositivoLogin] = useState({});
    [this.tpReuniao, this.setTpReuniao] = useState();

    this.evento = new EventoModel();
    this.service = new EventoService();
    this.contribuicaoService = new ContribuicaoService();
    this.fileService = new FileService();
    this.convidadosService = new ConvidadosService();
    [this.existeContribuicao, this.setExisteContribuicao] = useState(false);

    if (isBlock) {
      [this.codContribuinteLogado, this.setCodContribuinteLogado] = useState(0);
    } else {
      [this.codContribuinteLogado, this.setCodContribuinteLogado] = useState(
        this.getCodContribuinte()
      );
    }

    [this.total, this.setTotal] = useState(0);
    [this.contribuicoesPublicadas, this.setContribuicoesPublicadas] = useState(
      []
    );
    [this.dsLinkNormaDefinitiva, this.setDsLinkNormaDefinitiva] = useState("");
  }

  async obterContribuicoesPublicadas() {
    this.start();
    try {
      const contribuicaoService = new ContribuicaoService();
      const res: any = await contribuicaoService.getContribuicoesPublicadas(
        this.getId()
      );
      if (!!res.result && res.result.length > 0) {
        this.setContribuicoesPublicadas([...res.result]);
      }
      this.stop();
    } catch (err) {
      console.log(err);
      this.stop();
    }
  }

  async init() {
    this.start();
    try {
      const dados = this.getUser();
      const state = this.location?.state ?? {};
      this.setIsView(state?.isView ?? false);

      if (dados !== undefined) {
        this.setEmpresaList(dados.dadosLoginUnico.empresaList);
        this.setCpf(dados.cpf);
        this.setNoUsuarioCadastro(dados.cpf);
      }
      const context: any = this;
      const _evento = await this.obterEvento(context);

      if (isEventoInterno(_evento)) {
        const eventoId = context.getId();
        sessionStorage.setItem("idEventoInterno", String(eventoId));
        ativarLayoutEventoInterno();
        const currentPathInterno = this.location?.pathname || "";
        if (
          currentPathInterno.includes("/public/evento/visualizar") ||
          currentPathInterno.includes("/evento/visualizar")
        ) {
          this.history.replace("/evento-interno", { id: eventoId });
          return;
        }
      }

      const sessaoList = await this.obterSessaoPresencial(context);

      const lista = EventoConstants.montarLista(
        !!sessaoList && sessaoList.length > 0,
        _evento.codSituacaoAudiencia == 5
      );
      this.setAbaList([...lista]);
      const params = new URLSearchParams(window.location.search);
      if (params.get("tab") != undefined) {
        this.handleTab(params.get("tab"));
      }

      const token = sessionStorage.getItem("tokenInvite");
      let contribuite: any = null;

      try {
        contribuite = await this.podeContribuir(
          _evento.codAudienciaPublica,
          dados?.dadosLoginUnico?.token?.email || dados?.email,
          token
        );

        if (!contribuite.podeContribuir) {
          this.history.replace("/home");
          return;
        }
      } catch (err) {
        console.log(err);
        this.history.replace("/home");
        return;
      }

      if (this.isAuthenticated()) {
        try {
          if (token && contribuite.semIdentificacao) {
            const linked = await this.vincularCpfAoToken(
              contribuite.cpf,
              contribuite.email
            );
            console.log(linked);
            ToastService.showSuccess("Token Validado com Sucesso");
            return;
          }
        } catch (err) {
          console.log(err);
          this.history.replace("/home");
          return;
        } finally {
          sessionStorage.removeItem("tokenInvite");
          sessionStorage.removeItem("tipoToken");
        }
      }

      const tp =
        Array.isArray(sessaoList) && sessaoList.length > 0
          ? Number(sessaoList[0].tpReuniao)
          : undefined;
      this.setTpReuniao(tp);
      const isRestrito = !!_evento?.stEventoRestrito || tp === 1;

      const currentPath = this.location?.pathname || "";
      const id = sessionStorage.getItem("codAudienciaPublica");

      if (isRestrito) {
        if (!currentPath.includes("/evento/visualizar")) {
          this.history.replace("/evento/visualizar", { id });
          return;
        }
      } else if (this.isAuthenticated()) {
        if (!currentPath.includes("/evento/visualizar")) {
          this.history.replace("/evento/visualizar", { id });
          return;
        }
      } else if (this.isAuthenticated()) {
        if (!currentPath.includes("/evento/visualizar")) {
          this.history.replace("/evento/visualizar", { id });
          return;
        }
      } else {
        if (!currentPath.includes("/public/evento/visualizar")) {
          this.history.replace("/public/evento/visualizar", { id });
          return;
        }
      }
    } finally {
      this.stop();
    }
  }

  private async vincularCpfAoToken(
    cpf: string,
    email: string
  ): Promise<boolean> {
    if (!cpf) {
      return false;
    }
    const tokenInvite = sessionStorage.getItem("tokenInvite");
    if (!tokenInvite) {
      return false;
    }
    const payload = {
      dsToken: tokenInvite,
      dsNumeroDoc: cpf,
      stTipo: 0,
      dsEmail: email,
    };
    const tipoToken = sessionStorage.getItem("tipoToken");
    try {
      let resultado: any = null;
      if (tipoToken === "Tomada de Subsídios") {
        resultado = await this.convidadosService.validarConviteTomadaSubsidio(
          payload
        );
      } else {
        resultado = await this.convidadosService.validarConvite(payload);
      }
      if (resultado) {
        sessionStorage.removeItem("tipoToken");
        sessionStorage.removeItem("tokenInvite");
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  async initEventoInterno() {
    this.start();
    try {
      const state = this.location?.state ?? {};
      this.setIsView(state?.isView ?? false);

      const context: any = this;

      const login = sessionStorage.getItem("login");
      const id = sessionStorage.getItem("idEventoInterno");

      if (login) {
        const cpf = await this.obterCpfUsuarioInterno(login);
        const membro = await this.obterMembroInterno(cpf);
        const existingMembro = JSON.parse(sessionStorage.getItem("membro") || "{}");
        const newMembro = {
          ...membro,
          cpf: cpf,
          codContribuinte:
            membro?.codContribuinte || existingMembro?.codContribuinte,
        };
        sessionStorage.setItem("membro", JSON.stringify(newMembro));
      }

      const _evento = await this.obterEventoInterno(context, id);
      const sessaoList = await this.obterSessaoPresencial(context);
      
      // const sessaoList = await this.obterSessaoPresencialInterno(context, id);

      const lista = EventoConstants.montarLista(
        !!sessaoList && sessaoList.length > 0,
        _evento.codSituacaoAudiencia == 5
      );
      this.setAbaList([...lista]);
      const params = new URLSearchParams(window.location.search);
      if (params.get("tab") != undefined) {
        this.handleTab(params.get("tab"));
      }
    } finally {
      this.stop();
    }
  }

  async obterSessaoPresencial(context: any) {
    let request: any;
    const user = context.getUser();
    if (!!user && !!user.contribuinte && !!user.contribuinte.codContribuinte) {
      request = context.service.getSessaoPresencial(
        context.getId(),
        context.getCodContribuinte()
      );
    } else {
      request = context.service.getSessaoPresencialSemLogin(context.getId());
    }
    try {
      const res = await request;
      if (!!res.result && res.result.length > 0) {
        context.setSessaoList(res.result);
      }
      return res.result;
    } catch (e) {
      return null;
    }
  }

  async obterEvento(context: any) {
    try {
      const { result }: any = await context.service.getPropostaID(
        context.getId()
      );
      if (result) {
        context.evento.setCodPropostaNorma(result[0].codPropostaNorma);
      }
      const proposta: any = await context.service.getProposta(
        result[0].codPropostaNorma
      );
      const anexoProposta = await context.service.getAnexoProposta(
        result[0].codPropostaNorma
      );

      const res: any = await context.service.getEvento(
        context.getId(),
        context.codContribuinteLogado + 0
      );
      context.evento.sync(res.result);

      if (proposta?.result?.items) {
        context.evento.setDispositivoList(proposta.result.items);
      } else if (proposta?.data?.result?.items) {
        context.evento.setDispositivoList(proposta.data.result.items);
      }

      context.setLista([]);
      context.extrairLista(anexoProposta.result);
      context.setExisteContribuicao(
        res.result.qtdContribuicoesPorContribuinte == 0
      );
      return res.result;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async podeContribuir(codAudienciaPublica: any, email: any, token: any) {
    const _evento = await this.service.canContribuite(
      codAudienciaPublica,
      email,
      token
    );
    return _evento.data.result;
  }

  extrairLista(propostaNorma: any) {
    const lista: any = [];
    if (!propostaNorma || propostaNorma.length <= 0) {
      return;
    }

    propostaNorma.forEach((m: any) => {
      if (m.codAnexoPropostaNorma) {
        lista.push(m);
      } else if (m.anexoPropostaNorma && m.anexoPropostaNorma.length > 0) {
        m.anexoPropostaNorma.forEach((n: any) => {
          lista.push(n);
        });
      }
    });
    lista.sort((a: any, b: any) => a.nuOrdem - b.nuOrdem);

    this.setLista(lista);
  }

  handleShow() {
    this.setShow(!this.show);
  }

  toggleCardExpanded() {
    this.setIsCardExpanded(!this.isCardExpanded);
  }

  handleTab(value: any) {
    this.setTab(value);
  }

  downloadPropostaNorma(e: any) {
    this.fileService.openAnexoPropostaNorma(e.codAnexoPropostaNorma);
    ToastService.showSuccess(Mensagem.DOWNLOAD_EM_PROGRESSO);
  }

  downloadNormaDefinitiva(e: any) {
    this.fileService.openAnexoNormaDefinitiva(e);
    ToastService.showSuccess(Mensagem.DOWNLOAD_EM_PROGRESSO);
  }

  downloadDegravacao(e: any) {
    this.fileService.openAnexoDegravacao(e);
    ToastService.showSuccess(Mensagem.DOWNLOAD_EM_PROGRESSO);
  }

  getRelatorio() {
    this.start();
    this.service
      .getRelatorio(this.getId())
      .then((res: any) => {
        this.stop();
        ToastService.showSuccess(Mensagem.DOWNLOAD_SUCESSO);
        this.downloadFile(
          res.data.fileBytes,
          res.data.nome,
          res.data.contentType
        );
      })
      .catch((err) => this.stop());
  }

  async obterEventoInterno(context: any, id: any) {
    this.start();
    try {
      const res: any = await this.service.getEvento(id, 0);
      this.stop();

      const { result }: any = await context.service.getPropostaID(
        context.getId()
      );
      if (result) {
        context.evento.setCodPropostaNorma(result[0].codPropostaNorma);
      }
      const proposta: any = await context.service.getProposta(
        result[0].codPropostaNorma
      );

      const anexoProposta = await context.service.getAnexoProposta(
        result[0].codPropostaNorma
      );

      if (proposta?.result?.items) {
        context.evento.setDispositivoList(proposta.result.items);
      } else if (proposta?.data?.result?.items) {
        context.evento.setDispositivoList(proposta.data.result.items);
      }

      context.extrairLista(anexoProposta.result);
      context.evento.sync(res.result);
      context.extrairLista(res.result.propostaNorma);
      context.setExisteContribuicao(
        res.result.qtdContribuicoesPorContribuinte == 0
      );
      return res.result;
    } catch (err) {
      this.stop();
      console.error(err);
      return null;
    }
  }

  async obterSessaoPresencialInterno(context: any, id: any) {
    this.start();
    let request: any;
    request = this.service.getSessaoPresencialSemLogin(id);
    try {
      const res = await request;
      this.stop();

      if (!!res.result && res.result.length > 0) {
        context.setSessaoList(res.result);
      }
      return res.result;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async obterCpfUsuarioInterno(login: any) {
    this.start();
    try {
      const res: any = await this.service.getCpfUsuarioInterno(login);
      this.stop();

      if (res?.result.length > 0) {
        return res.result[0].cpf;
      }

      return null;
    } catch (err) {
      this.stop();
      console.error(err);
      return null;
    }
  }

  async obterMembroInterno(cpf: any) {
    this.start();
    try {
      const res: any = await this.service.getMembroInterno(cpf);
      this.stop();

      if (res?.result.length > 0) {
        return res.result[0];
      }

      return null;
    } catch (err) {
      this.stop();
      console.error(err);
      return null;
    }
  }

  downloadTodosDocumentos(currentIndex = 0) {
    if (!this.lista || this.lista.length <= 0) {
      return;
    }
    const lista: any = this.lista.map((m: any) => m.codAnexoPropostaNorma);
    if (!lista || lista.length <= 0) {
      ToastService.showWarn("Nenhum anexo encontrado.");
      return;
    }
    this.start();
    if (currentIndex >= lista.length) {
      ToastService.showInfo(
        Mensagem.DOWNLOAD_MULTIPLOS.replace("$qtde", lista.length)
      );
      this.stop();
      return;
    }
    this.fileService
      .downloadAnexoPropostaNorma(String(lista[currentIndex]))
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `documento_${lista[currentIndex]}.pdf`;
        link.click();
      });

    const next = currentIndex + 1;
    const that = this;
    setTimeout(() => {
      that.downloadTodosDocumentos(next);
    }, 5000);
  }

  downloadTodosAnexos(currentIndex = 0) {
    if (!this.lista || this.lista.length <= 0) {
      return;
    }
    const listaIds: any = this.lista.map((m: any) => m.codAnexoPropostaNorma);
    if (!listaIds || listaIds.length <= 0) {
      ToastService.showWarn("Nenhum anexo encontrado.");
      return;
    }

    if (currentIndex === 0) {
      this.start();
    }

    if (currentIndex >= listaIds.length) {
      ToastService.showInfo(
        Mensagem.DOWNLOAD_MULTIPLOS.replace("$qtde", String(listaIds.length))
      );
      this.stop();
      return;
    }

    this.fileService.downloadViaIframe(listaIds[currentIndex]);

    setTimeout(() => {
      this.downloadTodosAnexos(currentIndex + 1);
    }, 600);
  }

  abrirModalLogin(dispositivo: any) {
    this.setVisibleLogin(true);
    this.setDispositivoLogin(dispositivo);
  }

  navegarAposLoginInterno(dispositivo: any) {
    this.setVisibleLogin(false);
    if (dispositivo?.id) {
      this.history.push("/evento-interno-contribuicao", {
        id: dispositivo.id,
        codAudienciaPublica: dispositivo.codAudienciaPublica,
      });
    } else {
      this.history.push("/evento-interno", {
        id: dispositivo.codAudienciaPublica,
      });
    }
  }
}
